import * as React from "react"

import { cn } from "@javascript/components/utils"

export type DocHeading = {
  id: string
  text: string
}

export function DeveloperDocsToc({
  headings,
  activeId,
  className
}: {
  headings: DocHeading[]
  activeId?: string | null
  className?: string
}) {
  if (headings.length <= 1) return null

  return (
    <nav
      data-slot="developer-docs-toc"
      aria-label="On this page"
      className={cn("flex flex-col gap-1", className)}
    >
      {headings.map((heading) => {
        const isActive = heading.id === activeId

        return (
          <a
            key={heading.id}
            href={`#${heading.id}`}
            aria-current={isActive ? "location" : undefined}
            className={cn(
              "rounded-md px-3 py-1.5 text-sm",
              isActive
                ? "font-medium text-foreground"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {heading.text}
          </a>
        )
      })}
    </nav>
  )
}
